<template>
  <div 
    class="image-flow" 
    :style="{
      'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
      'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
      'padding': cc.is_vertical ? cc.padding ?  '0 ' + cc.padding + 'px' : '0 4px' : '0'
    }"
    v-bg="cc.modal_bg ? 'url( ' + cc.modal_bg + ') repeat-y center / 100% auto' : ''"
  >
    <template v-if="cc.is_vertical">
      <div class="left-flow" ref="left-flow">
        <div class="item" v-for="item, index in leftImgList" :key="index + 'left-flow'" @click="openUrl(item)">
          <div :class="'head-img cate' + item.head_img_type">
            <img v-src="item.head_img">
            <div class="video" v-if="item.has_video">
              <img src="https://cdn.max-c.com/wiki/1000000311/video.png?v=2">
            </div>
          </div>
          <div class="content" :style="{ 'background' : cc.content_bg_color }">
            <div class="title" :style="{ 'color' : cc.title_font_color }" v-html="replaceEmoji(item.title)"></div>
            <div class="user-like">
              <div class="user">
                <div class="avatar">
                  <img v-src="item.author_info.avatar">
                </div>
                <div class="name" :style="{ 'color' : cc.name_font_color }">
                  {{item.author_info.username}}
                </div>
              </div>
              <div class="like">
                <div class="img">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.44013 4.41787L11.0929 4.51126C11.5417 4.52706 11.98 4.6508 12.3707 4.87198L12.7532 5.0885C13.2916 5.3933 13.5426 6.03332 13.3549 6.62249C13.2941 6.81325 13.2426 6.9991 13.2005 7.18002C13.1815 7.26158 13.172 7.34501 13.172 7.42871L13.1591 8.10484C13.1516 8.49882 13.0745 8.88839 12.9314 9.2556L12.6584 9.95623C12.6286 10.03 12.6069 10.1068 12.5937 10.1852L12.4484 11.0488C12.3911 11.3899 12.2886 11.7219 12.1437 12.036L12.069 12.198C11.8904 12.5852 11.5026 12.8333 11.1198 12.8333H6.52607C5.69074 12.8333 5.10657 12.6784 4.61201 12.4507V4.41787C5.04883 4.08356 5.47498 3.72278 5.63376 3.42892C6.24052 2.30603 5.63376 1.21613 6.75053 0.662935C7.26317 0.409001 8.99852 0.545492 8.44013 4.41787ZM3.84637 4.41138V12.4504L1.60364 12.7708C1.39434 12.8007 1.20043 12.6553 1.17053 12.446C1.16797 12.4281 1.16669 12.41 1.16669 12.3919V4.79419C1.16669 4.58277 1.33808 4.41138 1.5495 4.41138H3.84637Z" :fill="cc.num_font_color"/>
                  </svg>  
                </div>
                <div class="num" :style="{ 'color' : cc.num_font_color }">
                  {{item.up}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-flow" ref="right-flow">
        <div class="item" v-for="item, index in rightImgList" :key="index + 'right-flow'" @click="openUrl(item)">
          <div :class="'head-img cate' + item.head_img_type">
            <img v-src="item.head_img">
            <div class="video" v-if="item.has_video">
              <img src="https://cdn.max-c.com/wiki/1000000311/video.png?v=2">
            </div>
          </div>
          <div class="content" :style="{ 'background' : cc.content_bg_color }">
            <div class="title" :style="{ 'color' : cc.title_font_color }"  v-html="replaceEmoji(item.title)"></div>
            <div class="user-like">
              <div class="user">
                <div class="avatar">
                  <img v-src="item.author_info.avatar">
                </div>
                <div class="name" :style="{ 'color' : cc.name_font_color }">
                  {{item.author_info.username}}
                </div>
              </div>
              <div class="like">
                <div class="img">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.44013 4.41787L11.0929 4.51126C11.5417 4.52706 11.98 4.6508 12.3707 4.87198L12.7532 5.0885C13.2916 5.3933 13.5426 6.03332 13.3549 6.62249C13.2941 6.81325 13.2426 6.9991 13.2005 7.18002C13.1815 7.26158 13.172 7.34501 13.172 7.42871L13.1591 8.10484C13.1516 8.49882 13.0745 8.88839 12.9314 9.2556L12.6584 9.95623C12.6286 10.03 12.6069 10.1068 12.5937 10.1852L12.4484 11.0488C12.3911 11.3899 12.2886 11.7219 12.1437 12.036L12.069 12.198C11.8904 12.5852 11.5026 12.8333 11.1198 12.8333H6.52607C5.69074 12.8333 5.10657 12.6784 4.61201 12.4507V4.41787C5.04883 4.08356 5.47498 3.72278 5.63376 3.42892C6.24052 2.30603 5.63376 1.21613 6.75053 0.662935C7.26317 0.409001 8.99852 0.545492 8.44013 4.41787ZM3.84637 4.41138V12.4504L1.60364 12.7708C1.39434 12.8007 1.20043 12.6553 1.17053 12.446C1.16797 12.4281 1.16669 12.41 1.16669 12.3919V4.79419C1.16669 4.58277 1.33808 4.41138 1.5495 4.41138H3.84637Z" :fill="cc.num_font_color"/>
                  </svg>  
                </div>
                <div class="num" :style="{ 'color' : cc.num_font_color }">
                  {{item.up}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="horizon-flow" v-else>
      <div class="img-wrapper">
        <div class="img-list" :style="{'padding': cc.padding ?  '0 ' + cc.padding + 'px' : '0 4px'}">
          <div class="item" v-for="item, index in cd.link_list" :key="index + 'left-flow'" @click="openUrl(item)">
            <div :class="'head-img cate' + item.head_img_type">
              <img v-src="item.head_img">
              <div class="video" v-if="item.has_video">
                <img src="https://cdn.max-c.com/wiki/1000000311/video.png?v=2">
              </div>
            </div>
            <div class="content" :style="{ 'background' : cc.content_bg_color }">
              <div class="title" :style="{ 'color' : cc.title_font_color }" v-html="replaceEmoji(item.title)"></div>
              <div class="user-like">
                <div class="user">
                  <div class="name" :style="{ 'color' : cc.name_font_color }">
                    {{item.author_info.username}}
                  </div>
                </div>
                <div class="like">
                  <div class="img">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.44013 4.41787L11.0929 4.51126C11.5417 4.52706 11.98 4.6508 12.3707 4.87198L12.7532 5.0885C13.2916 5.3933 13.5426 6.03332 13.3549 6.62249C13.2941 6.81325 13.2426 6.9991 13.2005 7.18002C13.1815 7.26158 13.172 7.34501 13.172 7.42871L13.1591 8.10484C13.1516 8.49882 13.0745 8.88839 12.9314 9.2556L12.6584 9.95623C12.6286 10.03 12.6069 10.1068 12.5937 10.1852L12.4484 11.0488C12.3911 11.3899 12.2886 11.7219 12.1437 12.036L12.069 12.198C11.8904 12.5852 11.5026 12.8333 11.1198 12.8333H6.52607C5.69074 12.8333 5.10657 12.6784 4.61201 12.4507V4.41787C5.04883 4.08356 5.47498 3.72278 5.63376 3.42892C6.24052 2.30603 5.63376 1.21613 6.75053 0.662935C7.26317 0.409001 8.99852 0.545492 8.44013 4.41787ZM3.84637 4.41138V12.4504L1.60364 12.7708C1.39434 12.8007 1.20043 12.6553 1.17053 12.446C1.16797 12.4281 1.16669 12.41 1.16669 12.3919V4.79419C1.16669 4.58277 1.33808 4.41138 1.5495 4.41138H3.84637Z" :fill="cc.num_font_color"/>
                    </svg>  
                  </div>
                  <div class="num" :style="{ 'color' : cc.num_font_color }">
                    {{item.up}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { utils } from '_lib/utils'
import { ComponentCommonMixin } from '../mixin'
import { throttle } from 'lodash'
import { getData } from '_api/activity/cpt-image-flow.js'
import Emoji from '@/common/emoji'
let emoji = new Emoji()

export default {
  name: 'cpt-image-flow',
  mixins: [ ComponentCommonMixin ],
  data () { 
    return {
      leftImgList: [],
      rightImgList: [],

      more_lock: false,
      more_finished: false,
      params: {
        limit: 20,
        offset: 20
      }
    }
  },
  created () {
    this.dealList(this.cd.link_list)
  },
  mounted () {
    this.cc.is_vertical && window.addEventListener('scroll', throttle(this.lazyLoading, 100));
  },
  components: {
  },
  methods: {
    dealList (list) {
      let originLength = this.leftImgList.length + this.rightImgList.length
      for (let i in list) {
        i = parseInt(i)
        if ((i + 1 + originLength) % 2 !== 0) {
          this.leftImgList.push(list[i])
        } else {
          this.rightImgList.push(list[i])
        }
      }
    },
    openUrl (item) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      this.reportData('.' + item.link_id)
      if (item.click_type === 'openurl') {
        utils.executeProtocol({
          protocol_type: 'openWindow',
          webview: {
            url: item.click_param
          }
        })
      }
    },
    getMore() {
      this.more_lock = true
      getData({...this.params, act_id: (this.act_id || this.querys.act_id), group_id: this.cc.group_id || '-1'}).then((res) => {
        if(res.data.status == 'ok') {
          this.params.offset += this.params.limit
          this.dealList(res.data.result.links || [])
          this.more_lock = false
          if (!res.data.result.links || res.data.result.links.length == 0) {
            this.more_finished = true
          }
        }
      })
    },
    lazyLoading () {
      if (this.more_lock) {
        return
      }
      if (this.more_finished) {
        return
      }
      const last_items = [this.$refs['left-flow'].querySelector('.item:last-child'), this.$refs['right-flow'].querySelector('.item:last-child')];
      let h = Math.max(window.innerHeight - last_items[0].getBoundingClientRect().bottom, window.innerHeight - last_items[1].getBoundingClientRect().bottom)
      if (h >= -20) { 
        this.getMore()
      }
    },
    replaceEmoji (text) {
      return emoji.replaceEmojiByName(text)
    }
  }
 }
</script>

<style lang='less' scoped>
.image-flow {
  display: flex;
  .right-flow, .left-flow, .horizon-flow {
    display: flex;
    flex-flow: column;
    flex: 1;
    min-width: 0;
    .item {
      border-radius: 5px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .head-img {
        position: relative;
        background: #D9D9D9;
        img {
          position: absolute;
          z-index: 1;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        .video {
          position: absolute;
          z-index: 1;
          top: 8px;
          left: 8px;
          width: 21px;
          height: 17px;
        }
        &.cate1 {
          padding-top: 75%;
        }
        &.cate2 {
          padding-top: 100%;
        }
        &.cate3 {
          padding-top: calc(100%/3*4);
        }
      }
      .content {
        padding: 8px 10px 10px;
        background: #FFFFFF;
        .title {
          margin-bottom: 10px;
          overflow:hidden; 
          text-overflow:ellipsis;
          display:-webkit-box; 
          -webkit-box-orient:vertical;
          -webkit-line-clamp:2; 
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: #14191E;
          word-break: break-all;
          word-wrap: break-word;
        }
        .user-like {
          display: flex;
          align-items: center;
          .user, .like {
            display: flex;
            align-items: center;
          }
          .user {
            width: 0;
            flex: 1;
            .avatar {
              margin-right: 5px;
              width: 18px;
              height: 18px;
              border-radius: 50%;
              overflow: hidden;
            }
            .name {
              width: 0;
              flex: 1;
              font-size: 11px;
              line-height: 15px;
              color: #64696E;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .like {
            margin-left: 4px;
            .img {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 14px;
              height: 14px;
              margin-right: 4px;
            }
            .num {
              font-size: 13px;
              line-height: 13px;
              color: #C8CDD2;
            }
          }
        }
      }
      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }
  .left-flow {
    margin-right: 4px;
  }
  .horizon-flow {
    display: flex;
    flex-flow: row;
    height: calc(((100vw - 30px) / 2.5) * (101 / 134) + 85px);
    max-height: 220px;
    overflow: hidden;
    .img-wrapper {
      display: flex;
      width: 100%;
      height: calc(100% + 30px);
      padding-bottom: 30px;
      overflow-x: auto;
      overflow-y: hidden;
      .img-list {
        display: flex;
        height: 100%;
        .item {
          // 一屏展示2.5个卡片
          // 134 / 101 图片宽高比
          width: calc((100vw - 30px) / 2.5);
          max-width: 180px;
          max-height: 220px;
          margin-bottom: 0;
          .head-img {
            padding-top: 75.37%;
          }
          &:not(:last-of-type) {
            margin-right: 8px;
          }
          .content {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 85px;
            padding: 10px;
            .title {
              font-size: 13px;
              margin-bottom: 5px;
            }
            .user-like {
              width: 100%;
              .user {
                width: 0;
                flex: 1;
                .name {
                  width: 0;
                  flex: 1;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  font-size: 12px;
                  line-height: 20px;
                }
              }
              .like {
                .num {
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>